import React from 'react';
const RefundPolicy = () => {
  return <div className="bg-gray-50 min-h-screen" data-id="element-437">
      <div className="bg-[#1a3a6c] text-white py-16" data-id="element-438">
        <div className="container mx-auto px-4 text-center" data-id="element-439">
          <h1 className="text-4xl font-bold mb-6" data-id="element-440">Refund Policy</h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-441">
            Information about our refund procedures and policies.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16" data-id="element-442">
        <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-443">
          <h2 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-444">
            Refund Policy – Opticore
          </h2>
          <p className="text-gray-700 mb-6" data-id="element-445">
            Thank you for choosing Opticore. We value your trust and are
            committed to ensuring your complete satisfaction with our services.
            If you have any concerns about your service plan or purchase, we'll
            work quickly and fairly to resolve them.
          </p>
          <div className="space-y-6" data-id="element-446">
            <div className="border-b pb-6" data-id="element-447">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-448">
                Cancellation & Refund Rights
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-449">
                You have the right to cancel your service plan within 14 days of
                purchase and receive a full refund. To do this, please contact
                us within the 14-day period, and we'll process your refund
                promptly.
              </p>
              <p className="text-gray-700" data-id="element-450">
                If you cancel after 14 days but within 28 days of purchase, you
                may be eligible for a partial refund at our discretion,
                depending on any services already provided under your plan.
                Please note that refunds or cancellations are not available
                after 28 days from the purchase date. We recommend reviewing
                your service plan carefully and contacting us as soon as
                possible if you wish to cancel.
              </p>
            </div>
            <div className="border-b pb-6" data-id="element-451">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-452">
                How to Request a Refund
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-453">
                To request a refund, please get in touch with our team using the
                contact details below:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4" data-id="element-454">
                <li data-id="element-455">Phone: 0800 055 4969</li>
                <li data-id="element-456">Email: raimanish3080@gmail.com</li>
              </ul>
              <p className="text-gray-700" data-id="element-457">
                We'll assess your request promptly and process any approved
                refunds. You'll receive confirmation once your refund has been
                completed.
              </p>
            </div>
            <div className="border-b pb-6" data-id="element-458">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-459">
                Payment Methods
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-460">
                Opticore accepts payments via:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4" data-id="element-461">
                <li data-id="element-462">Phone card payments</li>
                <li data-id="element-463">Online payments through our website</li>
                <li data-id="element-464">Cheques by post (please contact us for details)</li>
                <li data-id="element-465">BACS or Direct Debit</li>
              </ul>
              <p className="text-gray-700" data-id="element-466">
                Your 14-day cancellation right applies regardless of payment
                method.
              </p>
            </div>
            <div className="border-b pb-6" data-id="element-467">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-468">
                Refund Processing
              </h3>
              <p className="text-gray-700" data-id="element-469">
                All refunds will be issued to the original payment method used
                at purchase. For security reasons, refunds cannot be made to
                alternative accounts or cards.
              </p>
            </div>
            <div className="border-b pb-6" data-id="element-470">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-471">
                Payment Follow-Up
              </h3>
              <p className="text-gray-700" data-id="element-472">
                After purchasing a plan, Opticore will contact you to confirm
                activation and inform you when payment will be processed. Please
                ensure sufficient funds are available. If payment fails, we'll
                contact you to confirm whether you wish to proceed. Without a
                timely response, your plan will be cancelled.
              </p>
            </div>
            <div className="border-b pb-6" data-id="element-473">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-474">
                Authorised Payments
              </h3>
              <p className="text-gray-700" data-id="element-475">
                Payments must be made by the plan holder or an authorised
                individual. We don't accept payments made under power of
                attorney or other third-party authorisations.
              </p>
            </div>
            <div className="border-b pb-6" data-id="element-476">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-477">
                Claims & Support
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-478">
                To book a repair or submit a claim for your washing machine,
                boiler, or drainage system, please contact us immediately:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4" data-id="element-479">
                <li data-id="element-480">Email: raimanish3080@gmail.com</li>
                <li data-id="element-481">Phone: 0800 055 4969</li>
              </ul>
              <p className="text-gray-700" data-id="element-482">
                Our team will assist you and begin the repair process promptly.
              </p>
            </div>
            <div data-id="element-483">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-484">
                Dispute Resolution
              </h3>
              <p className="text-gray-700" data-id="element-485">
                If you have any issues related to payment or service, please
                contact Opticore first before raising a chargeback with your
                bank. We aim to resolve all concerns fairly and promptly.
                Initiating a chargeback without prior contact may delay your
                refund.
              </p>
            </div>
          </div>
          <div className="mt-8 p-6 bg-gray-50 rounded-lg" data-id="element-486">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-487">
              Need Help?
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-488">
              If you have any questions about refunds or payments, please don't
              hesitate to contact our customer service team.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-489">
              <a href="tel:08000554969" className="bg-[#3b82f6] text-white py-2 px-6 rounded-md font-medium hover:bg-[#1a3a6c] transition-colors text-center" data-id="element-490">
                Call 0800 055 4969
              </a>
              <a href="mailto:raimanish3080@gmail.com" className="bg-white text-[#1a3a6c] py-2 px-6 rounded-md font-medium border border-[#1a3a6c] hover:bg-gray-50 transition-colors text-center" data-id="element-491">
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default RefundPolicy;